/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignedLegalAgreementContentResponse
 */
export interface SignedLegalAgreementContentResponse {
    /**
     * Original HTML content in the accepted language, to sanitize when rendering.
     * @type {string}
     * @memberof SignedLegalAgreementContentResponse
     */
    content: string;
    /**
     * Values keyed by LegalAgreementVariable, frozen at acceptance time.
     * @type {{ [key: string]: string; }}
     * @memberof SignedLegalAgreementContentResponse
     */
    variableValuesSnapshot: { [key: string]: string; };
}

/**
 * Check if a given object implements the SignedLegalAgreementContentResponse interface.
 */
export function instanceOfSignedLegalAgreementContentResponse(value: object): value is SignedLegalAgreementContentResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('variableValuesSnapshot' in value) || value['variableValuesSnapshot'] === undefined) return false;
    return true;
}

export function SignedLegalAgreementContentResponseFromJSON(json: any): SignedLegalAgreementContentResponse {
    return SignedLegalAgreementContentResponseFromJSONTyped(json, false);
}

export function SignedLegalAgreementContentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignedLegalAgreementContentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'variableValuesSnapshot': json['variableValuesSnapshot'],
    };
}

export function SignedLegalAgreementContentResponseToJSON(value?: SignedLegalAgreementContentResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
        'variableValuesSnapshot': value['variableValuesSnapshot'],
    };
}

